import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      paddingLeft: 0,
      paddingTop: 0,
      paddingBottom: 0,
      position: 'relative',
      top: 0,
      left: 0,
      width: '19rem',
      maxHeight: '100vh',
      [theme.breakpoints.up('lg')]: {
        position: 'fixed',
      },
      [theme.breakpoints.up('xl')]: {
        width: '21.6rem',
      },
    },
    sidebarBg: {
      backgroundColor: 'white',
    },
    scrollAppSidebar: {
      // paddingTop: 30,
      paddingBottom: 20,
      height: 'calc(100vh - 58px) !important',
      // backgroundColor: '#7E57FE',
      color: 'black',
      [theme.breakpoints.up('xl')]: {
        height: 'calc(100vh - 65px) !important',
      },
    },
    drawerScrollAppSidebar: {
      paddingTop: 8,
      paddingBottom: 20,
      height: 'calc(100vh - 58px) !important',
      // backgroundColor: '#7E57FE',
      color: 'black',
      [theme.breakpoints.up('xl')]: {
        height: 'calc(100vh - 65px) !important',
      },
    },
    sidebarStandard: {
      height: '100%',
      width: '100%',
      // color: 'white',
      overflow: 'hidden',
    },
  };
});
export default useStyles;
